import { nextTick, onMounted, onUnmounted, ref } from "vue";

import ThreeEngine from "../utils/three/ThreeEngine";

import { useGlobalStore } from "../stores/global";
import { useCamera } from "./useCamera";
import { useGlobe } from "./useGlobe";

export const useScene = () => {
    const canvasRef = ref();
    const globalStore = useGlobalStore();

    const { cameraRig } = useCamera();
    const { globe } = useGlobe();

    let engine = undefined;

    onMounted(async () => {
        await nextTick();

        engine = new ThreeEngine(canvasRef);

        engine.addObject(globe);
        engine.addObject(cameraRig, false);

        globe.onReady = () => cameraRig.startEntrance(() => globalStore.setGlobeReady());
        if (globe.isReady) cameraRig.startEntrance(() => globalStore.setGlobeReady());
    });

    onUnmounted(() => {
        engine?.destroy();
        engine = undefined;
    });

    return { canvasRef, cameraRig };
};
